import { Component, Input } from '@angular/core';

import { Breadcrumb } from '@ap/mijn-template';
import { PegaChannelName } from '@ap/pega';

import { DistributionChannelType } from '../base-starter-app';
import { BaseStarterAppDirective } from '../base-starter-app/base-starter-app.directive';

@Component({
    selector: 'pega-starter-app-mijn',
    templateUrl: './starter-app-mijn.component.html',
    standalone: false
})
export class StarterAppMijnComponent extends BaseStarterAppDirective {
    @Input() public apPegaMijnBreadcrumb?: Breadcrumb;
    @Input() public override apPegaChannel: PegaChannelName = PegaChannelName.MIJN;

    protected distributionChannelType: DistributionChannelType = DistributionChannelType.MIJN;
}
